// User reducer types
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const LOADING_USER = "LOADING_USER";
export const SET_USER_SUMMARIES = "SET_USER_SUMMARIES";
export const SET_AUTH_USER_SUMMARY = "SET_AUTH_USER_SUMMARY";
export const SET_USER_RESULTS = "SET_USER_RESULTS";
export const UNLOADING_USER = "UNLOADING_USER";
export const SET_CONTEST = "SET_CONTEST";
export const SET_RESULT = "SET_RESULT";
export const SET_USER_CREDENTIAL = "SET_USER_CREDENTIAL";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_EXIBITIONS = "SET_EXIBITIONS";
export const SET_APP_STATE = "SET_APP_STATE";

// UI reducer types
export const SET_ERRORS = "SET_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const LOADING_DATA = "LOADING_DATA";
export const STOP_LOADING_UI = "STOP_LOADING_UI";
export const OPEN_SUCCESSBAR = "OPEN_SUCCESSBAR";
export const CLOSE_SUCCESSBAR = "CLOSE_SUCCESSBAR";
export const OPEN_ERRORBAR = "OPEN_ERRORBAR";
export const CLOSE_ERRORBAR = "CLOSE_ERRORBAR";
export const OPEN_TWEET_MODAL = "OPEN_TWEET_MODAL";
export const CLOSE_TWEET_MODAL = "CLOSE_TWEET_MODAL";
export const TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE";
